import type { CSSObject } from '@mui/material/styles';
import { designTokens } from '../tokens';

/** 일반 카드의 표면입니다. 클릭·선택·본문 배치는 각 패턴이 소유합니다. */
export const cardSurfaceStyles: CSSObject = {
  minWidth: 0,
  border: `1px solid ${designTokens.color.divider}`,
  borderRadius: designTokens.radius.surface,
  backgroundColor: designTokens.color.canvas,
  color: designTokens.color.primaryText,
  boxShadow: 'none',
};
